(function () {
  'use strict';

  if (!window.customElements) return;
  if (window.customElements.get('sticky-add-to-cart')) return;

  class StickyAddToCart extends HTMLElement {
    constructor() {
      super();
      this.frame = 0;
      this.isConnectedToPage = false;
      this.onAdd = this.onAdd.bind(this);
      this.onScrollOrResize = this.onScrollOrResize.bind(this);
      this.onSectionUnload = this.onSectionUnload.bind(this);
      this.onPageShow = this.onPageShow.bind(this);
    }

    connectedCallback() {
      this.bar = this.querySelector('[data-stuck]');
      this.button = this.querySelector('[data-sticky-add]');
      this.form = document.getElementById(this.dataset.formId);
      this.mainButton = this.form && this.form.querySelector('#ProductAddButton');

      if (!this.bar || !this.button || !this.form || !this.mainButton || this.isConnectedToPage) return;
      this.isConnectedToPage = true;

      this.footer = document.querySelector('footer, .shopify-section-footer, #shopify-section-footer');
      this.button.addEventListener('click', this.onAdd);
      window.addEventListener('scroll', this.onScrollOrResize, { passive: true });
      window.addEventListener('resize', this.onScrollOrResize, { passive: true });
      window.addEventListener('pageshow', this.onPageShow);
      document.addEventListener('shopify:section:unload', this.onSectionUnload);

      this.refreshVisibility();
    }

    disconnectedCallback() {
      if (this.button) this.button.removeEventListener('click', this.onAdd);
      window.removeEventListener('scroll', this.onScrollOrResize);
      window.removeEventListener('resize', this.onScrollOrResize);
      window.removeEventListener('pageshow', this.onPageShow);
      document.removeEventListener('shopify:section:unload', this.onSectionUnload);
      if (this.frame) window.cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.isConnectedToPage = false;
    }

    onScrollOrResize() {
      if (this.frame) return;
      this.frame = window.requestAnimationFrame(function () {
        this.frame = 0;
        this.refreshVisibility();
      }.bind(this));
    }

    onPageShow() {
      this.refreshVisibility();
    }

    refreshVisibility() {
      if (!this.bar || !this.mainButton) return;
      if (this.dataset.variantAvailable === 'false') {
        this.hide();
        return;
      }

      var buttonRect = this.mainButton.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

      /* Show the floating bar only after the real purchase button has moved
         above the viewport. Re-evaluate on every scroll in both directions. */
      var mainPurchaseButtonPassed = buttonRect.bottom <= 0;

      /* Keep the footer clear, but allow the bar to return as soon as the
         visitor scrolls back up and the footer no longer approaches the fold. */
      if (!this.footer || !document.documentElement.contains(this.footer)) {
        this.footer = document.querySelector('footer, .shopify-section-footer, #shopify-section-footer');
      }

      var footerRect = this.footer ? this.footer.getBoundingClientRect() : null;
      var footerApproaching = !!footerRect && footerRect.bottom > 0 && footerRect.top < viewportHeight + 24;

      if (mainPurchaseButtonPassed && !footerApproaching) {
        this.show();
      } else {
        this.hide();
      }
    }

    show() {
      if (this.dataset.variantAvailable === 'false') {
        this.hide();
        return;
      }
      if (this.bar) this.bar.setAttribute('data-stuck', 'true');
    }

    hide() {
      if (this.bar) this.bar.setAttribute('data-stuck', 'false');
    }

    onAdd() {
      if (!this.form || !this.mainButton || this.mainButton.disabled) return;
      this.mainButton.click();
    }

    onSectionUnload(event) {
      if (!event.detail) return;
      var section = this.closest('.shopify-section');
      if (section && section.id === 'shopify-section-' + event.detail.sectionId) {
        this.disconnectedCallback();
      }
    }
  }

  window.customElements.define('sticky-add-to-cart', StickyAddToCart);
})();
